import createIcon from '../../createIcon';

/**
 * @component @name Details
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0wyIDIxSDIyTDEyIDNaTTEzIDguOTJMMTguNiAxOUgxM1Y4LjkyWk0xMSA4LjkyVjE5SDUuNEwxMSA4LjkyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Details = createIcon('Details', [
  [
    'path',
    { d: 'M12 3L2 21H22L12 3ZM13 8.92L18.6 19H13V8.92ZM11 8.92V19H5.4L11 8.92Z', key: 'w2eodw' },
  ],
]);

export default Details;
